var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBox = function SvgIconBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.664 1.076A1 1 0 0 0 7.52.98L1.654 4.402a1 1 0 0 0-.365 1.653l2.235 2.207v6.582a1 1 0 0 0 .526.88l6.484 3.491a.995.995 0 0 0 .98 0l6.484-3.49a1 1 0 0 0 .526-.881v-4a1 1 0 1 0-2 0v3.402l-4.5 2.423v-4.728l5.974-3.217c.168-.09.3-.222.39-.375l2.323-2.293a1 1 0 0 0-.365-1.654L14.48.98a1 1 0 0 0-1.145.096L11 3.022 8.664 1.076Zm8.652 5.52 1.049-1.034-4.288-2.501-1.305 1.088 4.544 2.447ZM9.247 4.165 7.922 3.06l-4.287 2.5 1.066 1.052 4.546-2.448ZM5.524 8.44v5.805l4.5 2.423v-4.728L7.05 10.34a1 1 0 1 1 .948-1.761l3.026 1.63 4.391-2.365-4.39-2.364-5.5 2.961Z",
    fill: "#000"
  })));
};
export default SvgIconBox;